import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ElementRef,
  NgZone,
  ViewChild,
  Input,
} from '@angular/core';
// import { GeocodeService } from 'src/app/services/';
import { GeocodeService } from '../services/geocode.service';

// import { updateBrowserLatLng } from 'src/app/utils/common.util';
//import { Store } from '@ngrx/store';
import { MapsAPILoader } from '@agm/core';
//import { NotificationsService } from 'angular2-notifications';
import { GMAPS_NO_ZIPCODE, GMAPS_NO_CITY } from '../services/constants';
import { MAPS_COUNTRY_CODE } from '../services/constants';

declare var google: any;

@Component({
  selector: 'location-picker',
  templateUrl: './location-picker.component.html',
  styleUrls: ['./location-picker.component.scss'],
})
export class LocationPickerComponent implements OnInit {
  @Input() modalOptions:any;
  @Output() locationPicker: EventEmitter<any> = new EventEmitter<any>();
 // @ViewChild('googleAutocomplete') public searchElementRef: ElementRef;
  @ViewChild('googleAutocomplete', { static: true }) searchElementRef: any;
  lat: any;
  lng: any;
  location: any;
  formatted_address: any;
  zip: any;
  locationName: any;
  constructor(
    private ngZone: NgZone,
    private geocoder: GeocodeService,
    //private store: Store<any>,
    private mapsAPILoader: MapsAPILoader,
   // private notification: NotificationsService
  ) {}

  ngDoCheck() {
    if (this.modalOptions.locationName){
       this.locationName = this.modalOptions.locationName;
    }
      
  }

  ngOnInit() {
    if (!this.modalOptions) this.modalOptions = {};
    this.mapsAPILoader.load().then(() => {
      let autocomplete = new google.maps.places.Autocomplete(
        this.searchElementRef.nativeElement,
        {}
      );
      console.log(autocomplete);
      autocomplete.setComponentRestrictions({ country: MAPS_COUNTRY_CODE });

      if (!this.modalOptions.fullAddress) autocomplete.setTypes(['(cities)']);

      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          const place = autocomplete.getPlace();
          //console.log(place)
          this.formatted_address = place.formatted_address;
          if (!place.place_id) return;
          if (place.geometry) {
            this.lat = place.geometry.location.lat();
            this.lng = place.geometry.location.lng();
          }
          const values = this.geocoder.formatAddress({
            address_components: place.address_components,
          });

          if ((values.zip || '').trim().length === 0) {
            this.geocoder.geocode(this.lat, this.lng).subscribe((response: any) => {
              if ((response.zip || '').trim().length === 0) {
               // this.notification.error(GMAPS_NO_ZIPCODE);
                return;
              }
              if ((response.city || '').trim().length === 0) {
                //this.notification.error(GMAPS_NO_CITY);
                return;
              }
              this.location = response.city;
              this.zip = response.zip;
              // updateBrowserLatLng(this.store, {
              //   LatVal: this.lat,
              //   LngVal: this.lng,
              //   zipcode: response.zip,
              // });
              this.closeLocation();
            });
          } else {
            if ((values.city || '').trim().length === 0) {
             // this.notification.error(GMAPS_NO_CITY);
              return;
            }
            this.zip = values.zip;
            this.location = values.city;
            // updateBrowserLatLng(this.store, {
            //   LatVal: this.lat,
            //   LngVal: this.lng,
            //   zipcode: values.zip,
            // });
            this.closeLocation();
          }
        });
      });
    });
  }
  ngOnChanges() {
    // this.locationName = '';
  }

  closeLocation() {
    this.locationPicker.emit({
      name: this.location,
      formatted_address: this.formatted_address,
      latitude: this.lat,
      longitude: this.lng,
      zip: this.zip,
    });
  }
}
